const theme = {
  global: {
    font: {
      family: "Poppins",
    },
  },
};

export default theme;
